import { ISelection, IPlaceRequest, IPlaceResult } from './interfaces';
import Axios from 'axios';
import { config } from '@/../app.config';

export default {
  SET_PICK: ({ commit, getters }: any, pick: ISelection): void => {
    commit('CART_REMOVE', {pick: pick, classic: getters.ISCLASSIC})
    commit('CART_ADD', {pick: pick, classic: getters.ISCLASSIC})
  },
  REMOVE_PICK: ({ commit, getters }: any, pick: ISelection): void => {
    commit('CART_REMOVE', {pick: pick, classic: getters.ISCLASSIC})
  },
  MARK_PICK_INVALID: ({ commit, getters }: any, matchups: string[]): void => {
    commit('MARK_PICK_INVALID', {matchups: matchups, classic: getters.ISCLASSIC})
  },
  CLEAR_CART: ({ commit, getters }: any): void => {
    commit('CLEAR_CART', getters.ISCLASSIC)
  },
  PROCESS_CART: ({ commit, getters }: any, request: IPlaceRequest): Promise<IPlaceResult> => {
    return Axios.post(`${config.apiEndpoint}/place`, request)
    .then( res => {
      return res.data
    })
    .catch( err => {
      return {errorCode: -1 , errorList: []} as IPlaceResult
    })
  }
};
